import React from 'react'
import { Box, Button } from '@mui/material'
import OpsotDrawer from '../../ui/OpsotDrawer/index'
import OpsotTypography from '../../ui/OpsotTypography/index'
import OpsotButton from '../../ui/OpsotButton/index'
import { useGlobalStore } from '../../../services/store/store'

export const ExitModal = ({ handleChange, isExitOpen, setIsExitOpen }) => {
	const setLoggingOut = useGlobalStore((state) => state.setLoggingOut)
	const resetAuth = useGlobalStore((state) => state.resetAuth)
	const handleClick = () => {
		setLoggingOut(true)
		resetAuth()
		handleChange('https://www.college.police.uk/')
	}
	return (
		<OpsotDrawer
			isOpen={isExitOpen}
			dismissText="Cancel"
			onDismiss={() => setIsExitOpen(false)}
			title="Exit National Operating Model?"
			body={
				<Box>
					<OpsotTypography
						content="This will end your session, you will need to request a new code for
						your next visit."
						sx={{ marginBottom: '2rem' }}
					/>
					<OpsotButton
						variant="contained"
						onClick={() => handleClick()}
						text="Confirm and exit"
					/>
				</Box>
			}
		/>
	)
}
